import React, { useEffect, useRef } from 'react';
import Marzipano from 'marzipano';

const MarzipanoTour = ({ sceneId = '0-1', containerStyle = {} }) => {
  const panoElementRef = useRef(null);
  const viewerRef = useRef(null);

  useEffect(() => {
    if (!panoElementRef.current) return;

    // Sample data for the scene
    const sceneData = {
      id: sceneId,
      name: "Tour 360°",
      levels: [
        {
          tileSize: 256,
          size: 256,
          fallbackOnly: true
        },
        {
          tileSize: 512,
          size: 512
        },
        {
          tileSize: 512,
          size: 1024
        },
        {
          tileSize: 512,
          size: 2048
        }
      ],
      faceSize: 2048,
      initialViewParameters: {
        pitch: 0,
        yaw: 0,
        fov: Math.PI / 2
      },
      linkHotspots: [],
      infoHotspots: []
    };

    // Initialize viewer
    const viewerOpts = {
      controls: {
        mouseViewMode: 'qtvr'
      }
    };

    const viewer = new Marzipano.Viewer(panoElementRef.current, viewerOpts);
    viewerRef.current = viewer;

    // Create scene
    const urlPrefix = "/tiles";
    const source = Marzipano.ImageUrlSource.fromString(
      urlPrefix + "/" + sceneData.id + "/{z}/{f}/{y}/{x}.jpg",
      { cubeMapPreviewUrl: urlPrefix + "/" + sceneData.id + "/preview.jpg" }
    );
    const geometry = new Marzipano.CubeGeometry(sceneData.levels);

    const limiter = Marzipano.RectilinearView.limit.traditional(sceneData.faceSize, 100 * Math.PI / 180, 120 * Math.PI / 180);
    const view = new Marzipano.RectilinearView(sceneData.initialViewParameters, limiter);

    const scene = viewer.createScene({
      source: source,
      geometry: geometry,
      view: view,
      pinFirstLevel: true
    });

    // Switch to the scene
    scene.switchTo();

    // Set up autorotate
    const autorotate = Marzipano.autorotate({
      yawSpeed: 0.03,
      targetPitch: 0,
      targetFov: Math.PI / 2
    });
    viewer.startMovement(autorotate);

    return () => {
      if (viewerRef.current) {
        viewerRef.current.destroy();
      }
    };
  }, [sceneId]);

  return (
    <div
      ref={panoElementRef}
      style={{
        width: '100%',
        height: '100vh',
        position: 'relative',
        ...containerStyle
      }}
    />
  );
};

export default MarzipanoTour;